import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../index.css";

export default function TermsOfService() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-gradient-to-b from-slate-950 via-blue-950 to-slate-900 px-6 py-16 text-white">
        <div className="mx-auto max-w-3xl rounded-[2rem] border border-white/10 bg-white/10 p-8 shadow-2xl shadow-black/20 backdrop-blur md:p-12">
          <h1 className="mb-8 text-center text-4xl font-bold tracking-tight text-white">Terms of Service</h1>
          <p className="mb-6 leading-relaxed text-slate-200">
            These Terms govern your use of Lion Pride Financial’s website, educational content, forms, and
            related services. By using them, you agree to these Terms. If you do not agree, do not use the
            services.
          </p>
          <Section title="Educational Purpose">
            Content is provided for general educational and informational purposes. It is not individualized
            investment, legal, tax, accounting, or compliance advice and does not create an advisory, fiduciary,
            or client relationship.
          </Section>
          <Section title="Permitted Use">
            We grant you a limited, revocable, nonexclusive license to use the public website and its content
            for lawful personal or internal business purposes. You may not copy, resell, republish, scrape, or
            use the content or services to build a competing product without written permission.
          </Section>
          <Section title="SEC Intelligence Subscriptions">
            Commercial use of{" "}
            <a className="font-semibold text-cyan-200 underline hover:text-cyan-100" href="https://sec.lionpridefinancial.com">
              SEC Intelligence
            </a>{" "}
            is permitted with an active paid subscription, within the features, quotas, and authorized users
            included in the selected plan. SEC Intelligence accounts, subscriptions, APIs, research tools, and
            data are governed by its dedicated{" "}
            <a className="font-semibold text-cyan-200 underline hover:text-cyan-100" href="https://sec.lionpridefinancial.com/terms">
              Terms of Service
            </a>.
          </Section>
          <Section title="Acceptable Use">
            Do not misuse the services, interfere with security controls, bypass access or usage limits, share
            credentials outside your plan, introduce harmful code, or use the services in violation of law or
            another person’s rights.
          </Section>
          <Section title="Ownership and Third-Party Services">
            Lion Pride Financial retains all rights in its websites, software, branding, and original content.
            Third-party content and services remain subject to their owners’ terms. Links do not imply
            endorsement, and we are not responsible for third-party availability or practices.
          </Section>
          <Section title="Disclaimers and Liability">
            The services are provided “as is” and “as available.” To the fullest extent permitted by law, we
            disclaim implied warranties and are not liable for indirect, incidental, special, consequential, or
            punitive damages arising from use of the services.
          </Section>
          <Section title="Changes, Suspension, and Governing Law">
            We may update these Terms or change or suspend services when reasonably necessary. Material changes
            apply prospectively after notice. Maryland law governs these Terms, without regard to conflict-of-law
            rules, except where applicable law requires otherwise.
          </Section>
          <Section title="Contact">
            Questions may be sent to{" "}
            <a className="font-semibold text-cyan-200 underline hover:text-cyan-100" href="mailto:JGarcia@lionpridefinancial.com">
              JGarcia@lionpridefinancial.com
            </a>.
          </Section>
          <p className="mt-10 text-center text-sm italic text-slate-400">Effective July 31, 2026</p>
        </div>
      </main>
      <Footer />
    </>
  );
}

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="mb-3 border-l-4 border-cyan-300 pl-3 text-2xl font-semibold text-white">{title}</h2>
      <p className="leading-relaxed text-slate-200">{children}</p>
    </section>
  );
}
